
export const TvConductorProgramCardShimmer: React.FC = () => {

    return (
        <div className={`conductor w-100 px-3 py-1 border-bottom shimmer archive-episod`}>
        </div>
    );

};